<div class="outer-container">
  <div class="top-bar flex flex-row justify-between items-center px-3">
    <h2 class="pl-3">
      Purchase Order Management
    </h2>
    <div class="flex flex-row gap-1" *saFeatureFlag="'purchaseOrderDashboardCreatePurchaseOrder'">
      <button mat-flat-button color="primary" (click)="addForm()">ADD</button>
    </div>
  </div>
  <div class="flex flex-row gap-1 px-3 pt-1 items-center text-white">
    <i class="material-icons">
      search
    </i>
    <mat-form-field class="w-full">
      <mat-label class="text-white">
        Search
      </mat-label>
      <input matInput class="w-full" type="text" autofocus [formControl]="searchBar" />
    </mat-form-field>
  </div>
  <mat-tab-group>
    <mat-tab label="Active">
      <sa-lmo-active-purchase-orders-table
        [activePurchaseOrders]="activePurchaseOrders$ | async"
      ></sa-lmo-active-purchase-orders-table>
      <mat-spinner *ngIf="!(activePurchaseOrdersLoaded$ | async)"></mat-spinner>
    </mat-tab>
    <mat-tab label="Closed">
      <sa-lmo-closed-purchase-orders-table
        [closedPurchaseOrders]="closedPurchaseOrders$ | async"
      ></sa-lmo-closed-purchase-orders-table>
      <mat-spinner *ngIf="!(closedPurchaseOrdersLoaded$ | async)"></mat-spinner>
    </mat-tab>
  </mat-tab-group>
</div>
